import { Injectable, inject } from '@angular/core';
import { CrudQuery, CrudService } from '@shared/modules/crud/crud.service';
import { agentQuestion, Amenity, Consorcio, MODELNAME, Service, UrgentService } from './consorcios.config';
import { combineLatest, map, of } from 'rxjs';
import { doc, getFirestore, runTransaction, documentId } from '@firebase/firestore';

@Injectable({
    providedIn: 'root',
})
export class ConsorciosService {
    model = MODELNAME;
    crudService = inject(CrudService);
    collectionAmenities = 'amenities';
    collectionServices = 'services';
    collectionUrgentServices = 'urgentServices';
    collectionAgent = 'agentQuestions';

    /* getOne(uid: string) {
        const path = this.model + '/' + uid;
        this.crudService.setModel(path);
        return this.crudService.findFirst<Consorcio>('');
    } */

    getOneByAdmin(uid: string, adminUserId: string) {
        const path = this.model;
        this.crudService.setModel(path);
        

        const query: CrudQuery[] = [
            {
                field:documentId(), 
                operator: '==',
                value: uid,
                 orderBy: 'created_at',
                orderByDirection: 'desc',
            },
            {
                field: 'administrationUserId',
                operator: '==',
                value: adminUserId,
                orderBy: 'created_at',
                orderByDirection: 'desc',
            },
        ];
        return this.crudService.findOneWhere<Consorcio>(query, []);
    }

   /*  getAll() {
        this.crudService.setModel(this.model);
        return this.crudService.findAll<any>();
    } */


   
    getSome(fieldName: string, cuit: string) {
        this.crudService.setModel(this.model);
        
        const filter:any  = [{
            field: fieldName,
            operator: '==', 
            value: cuit,
        }];
        return this.findWhere(filter);     
    }

    findWhere(query: any, order: any = []) {
        return this.crudService.findWhere<any>(query, order);
    }
    
    update(uid: string, data: any) {
        const path = this.model + '/' + uid;
        this.crudService.setModel(path);
        return this.crudService.update('', data);
    }

    
    create(data: any) {
        const path = this.model;
        this.crudService.setModel(path);
        return this.crudService.add(data);
    }

    getConsorciosByAdministration(adminUserId: string){
        const path = this.model;
        this.crudService.setModel(path);
        

        const query: CrudQuery[] = [
          {
            field: 'administrationUserId',
            operator: '==',
            value: adminUserId,
            orderBy: 'created_at',
            orderByDirection: 'desc',
          },
        ];
        return this.crudService.findWhere<Consorcio>(query, []);
    }

      async countByAdministration(adminUserId: string): Promise<number> {
         const path = this.model;
        this.crudService.setModel(path);

         const query: CrudQuery[] = [
          {
            field: 'administrationUserId',
            operator: '==',
            value: adminUserId,
            orderBy: 'created_at',
            orderByDirection: 'desc',
          },
        ];

        
        const consorcios = await this.crudService.findWhereCount(query, []);
        return consorcios;
    }


    delete(uid: string) {
        const path = this.model;
        this.crudService.setModel(path);
        return this.crudService.delete(uid);
    }

    async numberTransaction() {
            const db = getFirestore();
            const paramRef = doc(db, 'parametry', 'global');
            try {
                const res = await runTransaction(db, async (t) => {
                const snap = await t.get(paramRef);
                if (!snap.exists()) {
                  throw "parametry/global document does not exist!";
                }
                const currentTotalConsorcios = snap.data()['totalConsorcios'] || 0;
                const newTotal = currentTotalConsorcios + 1
                t.set(paramRef, { totalConsorcios: newTotal }, { merge: true });
                return newTotal;
            });
            return res;
            } catch (e) {
                console.log('Transaction failure:', e);
                throw e;
            }
        }

    searchByDirectionAndNameAndAdmin(direction: string, name: string, adminUserId: string) {
        this.crudService.setModel(this.model);

         let result=of([]);
        const filter: any = [];

        const order: any[] = [];
         order.push({ orderBy: 'name', orderByDirection: 'asc' });
         filter.push({ field: 'administrationUserId', operator: '==', value: adminUserId });

        if (name && name.trim() !== '') {
            filter.push({ field: 'name', operator: '>=', value: name });
            filter.push({ field: 'name', operator: '<=', value: name + '\uf8ff' });
        }

        if (direction && direction.trim() !== ''){
            let grupoAddress=this.crudService.findWhere<any>([
                ...filter,
                {field:'location.address', operator: '>=', value: direction},
                { field: 'location.address', operator: '<=', value: direction + '\uf8ff' }],
                order);

             let grupoCity=this.crudService.findWhere<any>([
                ...filter,
                {field:'location.city', operator: '>=', value: direction},
                { field: 'location.city', operator: '<=', value: direction + '\uf8ff' }],
                order);

            let grupoProvince=this.crudService.findWhere<any>([
                ...filter,
                {field:'location.province', operator: '>=', value: direction},
                { field: 'location.province', operator: '<=', value: direction + '\uf8ff' }],
                order);

            /* result = combineLatest([grupoAddress, grupoCity,grupoProvince]).pipe(
                map(([firstResults, lastResults]) => {
                    const combined = [...firstResults, ...lastResults];
                    return combined.filter(
                        (item, index, self) => index === self.findIndex(
                            u => u.parentUid === item.parentUid)
                        );
                    })
                ); */
                result = combineLatest([grupoAddress, grupoCity, grupoProvince]).pipe(
                map(([addressResults, cityResults, provinceResults]) => {
                    const combined = [
                    ...addressResults,
                    ...cityResults,
                    ...provinceResults
                    ];
                    return combined.filter(
                    (item, index, self) =>
                        index === self.findIndex(u => u.uid === item.uid)
                    );
                })
                );

        }else{
             result = this.crudService.findWhere<any>(filter, order);
        }
        return result;
        
    }

    //subcolecciones

    //amenities
    createAmenity(uid: string, data: Amenity) {
        const path = `${this.model}/${uid}/${this.collectionAmenities}`;
        this.crudService.setModel(path);
        return this.crudService.add(data);
    }
    createManyAmenity(uid: string, data: Amenity[]) {
        const path = `${this.model}/${uid}/${this.collectionAmenities}`;
        this.crudService.setModel(path);
        return this.crudService.addMany(data);
    }

    updateManyAmenity(uid: string, oldObjects: any[],newObjects: any[]): Promise<void> {
        const path = `${this.model}/${uid}/${this.collectionAmenities}`;
        this.crudService.setModel(path);
        return this.crudService.updateMany(oldObjects,newObjects);
    }

    updateAmenity(idConsorcio: string, uid: string, data: Partial<Amenity>) {
        const path = `${this.model}/${idConsorcio}/${this.collectionAmenities}`;
        this.crudService.setModel(path);
        return this.crudService.update(uid, data);
    }

     getAllAmenities(uid: string) {
        this.crudService.setModel(
            this.model + '/' + uid + '/' + this.collectionAmenities
        );
        return this.crudService.findAll<Amenity>();
    }
    deleteAmenity(idConsorcio: string, uid: string) {
        const path = `${this.model}/${idConsorcio}/${this.collectionAmenities}`;
        this.crudService.setModel(path);
        return this.crudService.delete(uid);
    }

    //services
    createService(uid: string, data: Service) {
        const path = `${this.model}/${uid}/${this.collectionServices}`;
        this.crudService.setModel(path);
        return this.crudService.add(data);
    }
    createManyServices(uid: string, data: Service[]) {
        const path = `${this.model}/${uid}/${this.collectionServices}`;
        this.crudService.setModel(path);
        return this.crudService.addMany(data);
    }
    updateService(idConsorcio: string, uid: string, data: Partial<Service>) {
        const path = `${this.model}/${idConsorcio}/${this.collectionServices}`;
        this.crudService.setModel(path);
        return this.crudService.update(uid, data);
    }
    updateManyServices(uid: string, oldObjects: any[],newObjects: any[]): Promise<void> {
        const path = `${this.model}/${uid}/${this.collectionServices}`;
        this.crudService.setModel(path);
        return this.crudService.updateMany(oldObjects,newObjects);
    }
        getAllServices(uid: string) {
        this.crudService.setModel(
            this.model + '/' + uid + '/' + this.collectionServices
        );
        return this.crudService.findAll<Service>();
    }

    deleteService(idConsorcio: string, uid: string) {
        const path = `${this.model}/${idConsorcio}/${this.collectionServices}`;
        this.crudService.setModel(path);
        return this.crudService.delete(uid);
    }

    //urgent services
    createUrgentService(uid: string, data: UrgentService) {
        const path = `${this.model}/${uid}/${this.collectionUrgentServices}`;
        this.crudService.setModel(path);
        return this.crudService.add(data);
    }
    createManyUrgentServices(uid: string, data: UrgentService[]) {
        const path = `${this.model}/${uid}/${this.collectionUrgentServices}`;
        this.crudService.setModel(path);
        return this.crudService.addMany(data);
    }
    updateUrgentService(idConsorcio: string, uid: string, data: Partial<UrgentService>) {
        const path = `${this.model}/${idConsorcio}/${this.collectionUrgentServices}`;
        this.crudService.setModel(path);
        return this.crudService.update(uid, data);
    }

    updateManyUrgentServices(uid: string, oldObjects: any[],newObjects: any[]): Promise<void> {
        const path = `${this.model}/${uid}/${this.collectionUrgentServices}`;
        this.crudService.setModel(path);
        return this.crudService.updateMany(oldObjects,newObjects);
    }

        getAllUrgentServices(uid: string) {
        this.crudService.setModel(
            this.model + '/' + uid + '/' + this.collectionUrgentServices
        );
        return this.crudService.findAll<UrgentService>();
    }
    deleteUrgentService(idConsorcio: string, uid: string) {
        const path = `${this.model}/${idConsorcio}/${this.collectionUrgentServices}`;
        this.crudService.setModel(path);
        return this.crudService.delete(uid);
    }

    //agent questions
    createmanyAgentQuestions(uid: string, data: agentQuestion[]) { 
        const path = `${this.model}/${uid}/${this.collectionAgent}`;
        this.crudService.setModel(path);
        return this.crudService.addMany(data);
    }
    updateAgentQuestion(idConsorcio: string, uid: string, data: Partial<agentQuestion>) {
        const path = `${this.model}/${idConsorcio}/${this.collectionAgent}`;
        this.crudService.setModel(path);
        return this.crudService.update(uid, data);
    }

    updateOnlyManyAgentQuestions(uid: string,objects: any[]): Promise<void> {
        const path = `${this.model}/${uid}/${this.collectionAgent}`;
        this.crudService.setModel(path);
        return this.crudService.updateOnlyMany(objects);
    }

    updateManyAgentQuestions(uid: string, oldObjects: any[],newObjects: any[]): Promise<void> {
        const path = `${this.model}/${uid}/${this.collectionAgent}`;
        this.crudService.setModel(path);
        return this.crudService.updateMany(oldObjects,newObjects);
    }

    getAllAgentQuestions(uid: string) {
        this.crudService.setModel(
            this.model + '/' + uid + '/' + this.collectionAgent
        );
        return this.crudService.findAll<agentQuestion>();
    }
}
